import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CloseButton } from "react-bootstrap";
import { useWalletConnection } from "../../utility/useWalletConnection";
import { useData } from "../../utility/useData";
import { formatUnits } from "ethers";
import { useDispatch } from "react-redux";
import { getInfo, getPrizes } from "../../pages/Home/store";

import prizeCard2 from "../../assets/img/prizeDetail2.png";
import prizeCard3 from "../../assets/img/prizeDetail3.png";
import prizeCard4 from "../../assets/img/prizeDetail4.png";
import prizeCard5 from "../../assets/img/prizeDetail5.png";
import prizeMobile2 from "../../assets/img/prizeMobile2.png";
import prizeMobile3 from "../../assets/img/prizeMobile3.png";
import prizeMobile4 from "../../assets/img/prizeMobile4.png";
import prizeMobile5 from "../../assets/img/prizeMobile5.png";

const PrizeDetails = ({ onClose }) => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const {
    isConnected,
    connectedWalletInfo,
    address,
    chainId,
    signerVars,
    unSignerVars,
    mockVRF,
    errorMessage,
    clearError,
    open,
    connect,
    disConnect,
  } = useWalletConnection();

  const {
    decimals,
    initialResultMsg,
    initialData,
    reRender,
    poolData,
    showPoolDetail,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
  } = useData();

  const [isLoading, setIsLoading] = useState(true);
  const [filterLpwc, setFilterLpwc] = useState(0);
  const [isPrizes, setIsPrizes] = useState(null);
  const [prizes, setPrizes] = useState([]);
  const [contractInfo, setContractInfo] = useState(null);
  const [allSoldLpwc, setAllSoldLpwc] = useState(0);

  useEffect(() => {
    if (unSignerVars.contract && poolData && poolData.poolId > 0) {
      async function initialize() {
        setIsLoading(true);

        const info = await dispatch(
          getInfo({ dispatch, unSignerVars, poolId: poolData.poolId })
        )
          .then((result) => {
            console.log("getInfo:", result.payload);
            if (result.payload.result) {
              if (result.payload.result.prizeShareCount > 0) {
                setIsPrizes(true);
              } else {
                setIsPrizes(false);
              }
              setContractInfo(result.payload.result);
              return result.payload.result;
            }
          })
          .catch((error) => console.error(error));

        dispatch(
          getPrizes({
            dispatch,
            unSignerVars,
            poolId: poolData.poolId,
            prizeShareCount: info.prizeShareCount,
          })
        )
          .then(async (result) => {
            console.log("getPrizes:", result.payload);
            if (result.payload.result) {
              setPrizes(result.payload.result);

              let _lpwc = Number(
                await unSignerVars.contract.lastPrizeWinnerCount(
                  poolData.poolId
                )
              );
              setAllSoldLpwc(_lpwc);

              const assignTicketCount = info.assignTicketCount;
              if (
                assignTicketCount > info.prizeShareCount - 1 &&
                assignTicketCount <= _lpwc &&
                !result.payload.result[0].isDrawn
              ) {
                _lpwc = assignTicketCount - (info.prizeShareCount - 1);
              }
              setFilterLpwc(_lpwc);

              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          })
          .catch((error) => console.error(error));
      }
      console.log("prizes", prizes);
      initialize();
    }
  }, [poolData, unSignerVars]);

  return (
    <div className={"loader"}>
      <div className={"prtitle"}>
        <CloseButton
          style={{ top: "1%", right: "1%", position: "absolute" }}
          onClick={() => onClose()}
        />
        <div className="font-second prize-title">
          {poolData.name}
          <br />
          PRIZE DETAILS
        </div>
        <div className="w-100">
          {isLoading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Loading</span>
            </div>
          ) : isPrizes ? (
            <div className="d-flex align-items-center justify-content-center flex-column w-100">
              <div style={{ margin: "3% 0", width: "100%" }}>
                <div className="prize-info">
                  <div>Total Ticket: </div>
                  <div>{poolData.maxTicketCount} Ticket</div>
                </div>
                <div className="prize-info">
                  <div>Total Prize: </div>
                  <div>
                    {Number(formatUnits(poolData.totalPrizeToken, poolData.prizeTokenDecimals)).toFixed(2)} $
                    {poolData.prizeTokenSymbol}
                  </div>
                </div>
              </div>
              {/*prizes.length ==2 */}
              {prizes.length <= 2 && (
                <div className="prize-card-area">
                  <img
                    className="w-100 d-block d-md-none"
                    src={prizeMobile2}
                    alt=""
                  />
                  <img
                    className="w-100 d-md-block d-none"
                    src={prizeCard2}
                    alt=""
                  />
                  <div className="card-in pady14">
                    <div className="d-flex flex-wrap w-100 h-100">
                      {prizes.length > 0 &&
                        prizes.map((prize, index) => (
                          <div
                            className="card-item mobile-item2 w50"
                            key={index}
                          >
                            <div className="card-item-title">
                              {prize.prizeIndex === 0 && (
                                <>
                                  GRAND <br /> PRIZE
                                </>
                              )}
                              {prize.prizeIndex === 1 && (
                                <>
                                  PARTICIPATION <br /> PRIZE
                                </>
                              )}
                            </div>
                            <div className="card-item-prize">
                              {Number(
                                (formatUnits(poolData.totalPrizeToken, poolData.prizeTokenDecimals) *
                                  prize.share) /
                                  10000
                              )}
                              {" $"}
                              {poolData.prizeTokenSymbol}
                            </div>
                            <div className="card-item-share">
                              {Math.floor(prize.share / 100)}% <br /> OF THE
                              TOTAL PRIZE
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {/*prizes.length ==3 */}
              {prizes.length === 3 && (
                <div className="prize-card-area">
                  <img
                    className="w-100 d-none d-md-block"
                    src={prizeCard3}
                    alt=""
                  />
                  <img
                    className="w-100 d-block d-md-none"
                    src={prizeMobile3}
                    alt=""
                  />
                  <div className="card-in pady10">
                    <div className="d-flex flex-wrap w-100 h-100">
                      {prizes.length > 0 &&
                        prizes.map((prize, index) => (
                          <div
                            className="card-item mobile-item3 w33"
                            key={index}
                          >
                            <div className="card-item-title">
                              {prize.prizeIndex === 0 && (
                                <>
                                  GRAND <br /> PRIZE
                                </>
                              )}
                              {prize.prizeIndex === 1 && (
                                <>
                                  2ND <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 2 && (
                                <>
                                  PARTICIPATION <br /> PRIZE
                                </>
                              )}
                            </div>
                            <div className="card-item-prize">
                              {Number(
                                (formatUnits(poolData.totalPrizeToken, poolData.prizeTokenDecimals) *
                                  prize.share) /
                                  10000
                              )}
                              {" $"}
                              {poolData.prizeTokenSymbol}
                            </div>
                            <div className="card-item-share">
                              {Math.floor(prize.share / 100)}% <br /> OF THE
                              TOTAL PRIZE
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {/*prizes.length ==4 */}
              {prizes.length === 4 && (
                <div className="prize-card-area">
                  <img
                    className="w-100 d-none d-md-block"
                    src={prizeCard4}
                    alt=""
                  />
                  <img
                    className="w-100 d-block d-md-none"
                    src={prizeMobile4}
                    alt=""
                  />
                  <div className="card-in pady8">
                    <div className="d-flex flex-wrap w-100 h-100">
                      {prizes.length > 0 &&
                        prizes.map((prize, index) => (
                          <div
                            className="card-item mobile-item4 w25"
                            key={index}
                          >
                            <div className="card-item-title">
                              {prize.prizeIndex === 0 && (
                                <>
                                  GRAND <br /> PRIZE
                                </>
                              )}
                              {prize.prizeIndex === 1 && (
                                <>
                                  2ND <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 2 && (
                                <>
                                  3RD <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 3 && (
                                <>
                                  PARTICIPATION <br /> PRIZE
                                </>
                              )}
                            </div>
                            <div className="card-item-prize">
                              {Number(
                                (formatUnits(poolData.totalPrizeToken, poolData.prizeTokenDecimals) *
                                  prize.share) /
                                  10000
                              )}
                              {" $"}
                              {poolData.prizeTokenSymbol}
                            </div>
                            <div className="card-item-share">
                              {Math.floor(prize.share / 100)}% <br /> OF THE
                              TOTAL PRIZE
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {/*prizes.length ==5 */}
              {prizes.length >= 5 && (
                <div className="prize-card-area">
                  <img
                    className="w-100 d-none d-md-block"
                    src={prizeCard5}
                    alt=""
                  />
                  <img
                    className="w-100 d-block d-md-none"
                    src={prizeMobile5}
                    alt=""
                  />
                  <div className="card-in pady7">
                    <div className="d-flex flex-wrap w-100 h-100">
                      {prizes.length > 0 &&
                        prizes.map((prize, index) => (
                          <div
                            className="card-item mobile-item5 w20"
                            key={index}
                            style={
                              index === 0 && window.screen.width < 768
                                ? { marginLeft: "18%" }
                                : {} &&
                                  index === 1 &&
                                  window.screen.width < 768
                                ? { marginRight: "15%" }
                                : {}
                            }
                          >
                            <div className="card-item-title">
                              {prize.prizeIndex === 0 && (
                                <>
                                  GRAND <br /> PRIZE
                                </>
                              )}
                              {prize.prizeIndex === 1 && (
                                <>
                                  2ND <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 2 && (
                                <>
                                  3RD <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 3 && (
                                <>
                                  4TH <br /> PRIZE
                                </>
                              )}{" "}
                              {prize.prizeIndex === 4 && (
                                <>
                                  PARTICIPATION <br /> PRIZE
                                </>
                              )}
                            </div>
                            <div className="card-item-prize">
                              {Number(
                                (formatUnits(poolData.totalPrizeToken, poolData.prizeTokenDecimals) *
                                  prize.share) /
                                  10000
                              )}
                              {" $"}
                              {poolData.prizeTokenSymbol}
                            </div>
                            <div className="card-item-share">
                              {Math.floor(prize.share / 100)}% <br /> OF THE
                              TOTAL PRIZE
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              <div className="prize-bottom-info">
                PARTICIPATION PRIZE WILL BE EQUALLY DISTRIBUTED AMONG ALL
                PARTICIPANTS. <br /> EXCLUDING THOSE WITH THE TOP{" "}
                {filterLpwc > 0
                  ? filterLpwc
                  : poolData.maxTicketCount - (prizes.length - 1)}{" "}
                WINNING TICKETS.
              </div>
            </div>
          ) : (
            <div className={"error-msg"}>
              <div className="text-center fw-bold">PRIZE NOT SET</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrizeDetails;
